// import Axios from 'axios'
import moment from 'moment-mini'
// import md5 from 'md5' 2025-08-13 jazz
import Store from '../../store'
import { bus } from '../../app'

// Axios.defaults.headers.common['SRS-Key'] = process.env.MIX_API_KEY; //add global header

export class UserInfo{
	#axios; //2025-09-29 jazz

	constructor(axios) {
		this.#axios = axios;

		this.timerValue = 0;
		
		// system should logout if the browser or last opened tab was closed (in 15sec after closing)
		if (this.wasBrowserOrTabClosedAfterSignin()) {
			Store.dispatch('isLogged', false)
		}

		// every 15sec update browserOrTabActiveTimestamp property with new timestamp
		this.setBrowserOrTabActiveTimestamp(new Date());
			this.tabOrBrowserStillAliveInterval = setInterval(() => {
			this.setBrowserOrTabActiveTimestamp(new Date());
		}, 15000);
	}

	//2025-05-19 jazz, add free mem
	cleanInterval(){
		    if (this.tabOrBrowserStillAliveInterval) {
		        clearInterval(this.tabOrBrowserStillAliveInterval);
		        this.tabOrBrowserStillAliveInterval = null; 
		    }
		}

	  setBrowserOrTabActiveTimestamp(timeStamp) {
	    localStorage.setItem('browserOrTabActiveSessionTimestamp', `${timeStamp.getTime()}` );
	}

	wasBrowserOrTabClosedAfterSignin() {
	    const value = localStorage.getItem('browserOrTabActiveSessionTimestamp');

	    const lastTrackedTimeStampWhenAppWasAlive = value
	        ? new Date(Number(value))
	        : null;
	    
	    const currentTimestamp = new Date();
	    
	    const differenceInSec = moment(currentTimestamp).diff(
	        moment(lastTrackedTimeStampWhenAppWasAlive),
	        'seconds'
	    );

	    return !!lastTrackedTimeStampWhenAppWasAlive && differenceInSec > 15;
	}

    logOutUser = async () =>{
	    try{	
	        const loggedStatus = await this.#axios.post(`${process.env.MIX_API_BASEURL}/api/logout`, { email: Store.state.UserInfo.FullName }); //2024-10-11 jazz
		   		 Store.dispatch('isLogged', false); 

           //2025-05-19 jazz
           this.cleanInterval();
	    }catch{
	  	    return false
	    }	
	}
	
    async logInUser(email, password){
	    bus.$emit('setLoadingStatusMessage', `Loading user info...`)
	  	if (process.env.MIX_DEPLOYMENT == 'ichijo') {
	        //for aws
		    try{
		        const data = await this.#axios.post(`${process.env.MIX_API_BASEURL}/api/login`, {'email': email, 'password': password})

		        await new Promise(r => setTimeout(r, 1000)); 

			      await Store.dispatch('isLogged', true); 
			      return data;
		    }catch(error){
		        console.log(error)	
		    }
	    } else {
			    try{
			        const data = await this.#axios.post(`${process.env.MIX_API_BASEURL}/api/login`, {'email': email, 'password': password})

			        await new Promise(r => setTimeout(r, 500)); 
				      await Store.dispatch('isLogged', true);

							const adminrights = await this.#axios.get(`${process.env.MIX_API_BASEURL}/api/admin/${ email }`);

							if ( adminrights.data.isAdmin == '1') {
								Store.dispatch('isAdmin', '1'); 
							} else {
								Store.dispatch('isAdmin', '0'); 
							}

						  await Store.dispatch('isLogged', true); 

				      return data;
			    }catch(error){
			        console.log(error)	
			    }
	    }
	}

  //this functions checks everytime change of route if cookie is still valid or modified
	async isRouteNavigationValid(){
		try{
		    bus.$emit('setLoadingStatusMessage', `Authenticating user...`)
			await this.#axios.get(`${process.env.MIX_API_BASEURL}/api/serverCookie`)
			return true
		}catch{
		    return false
		}
	}
}
